import { IOpeningHour } from '@/api/restaurants/types/restaurant-types'
import { ITranslationKey } from '@/components/t'

export function parseReadableDayOpeningHours(
    openingHours: IOpeningHour[] | null,
    t: (tKey: ITranslationKey) => string
) {
    if (!openingHours) return t('restaurants.detail.openingHours.closed')

    return openingHours
        .map((openingHour) => {
            const openingTime = openingHour.openingTime
            const closingTime = openingHour.closingTime

            return `${openingTime} - ${closingTime}`
        })
        .join(', ')
}
